// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateWorkbookVariantMutationVariables = Types.Exact<{
  variantId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  description?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type UpdateWorkbookVariantMutation = {
  __typename?: "Mutation";
  updateWorkbookVariant: {
    __typename?: "UpdateWorkbookVariantPayload";
    variantId?: string | null;
  };
};

export const UpdateWorkbookVariantDocument = gql`
  mutation UpdateWorkbookVariant(
    $variantId: ID!
    $name: String
    $description: String
  ) {
    updateWorkbookVariant(
      variantId: $variantId
      name: $name
      description: $description
    ) {
      variantId
    }
  }
`;
export type UpdateWorkbookVariantMutationFn = Apollo.MutationFunction<
  UpdateWorkbookVariantMutation,
  UpdateWorkbookVariantMutationVariables
>;

/**
 * __useUpdateWorkbookVariantMutation__
 *
 * To run a mutation, you first call `useUpdateWorkbookVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkbookVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkbookVariantMutation, { data, loading, error }] = useUpdateWorkbookVariantMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateWorkbookVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkbookVariantMutation,
    UpdateWorkbookVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkbookVariantMutation,
    UpdateWorkbookVariantMutationVariables
  >(UpdateWorkbookVariantDocument, options);
}
export type UpdateWorkbookVariantMutationHookResult = ReturnType<
  typeof useUpdateWorkbookVariantMutation
>;
export type UpdateWorkbookVariantMutationResult =
  Apollo.MutationResult<UpdateWorkbookVariantMutation>;
export type UpdateWorkbookVariantMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkbookVariantMutation,
  UpdateWorkbookVariantMutationVariables
>;
